import { z } from "zod";
import { PLAID_INSTITUTIONS_NAMES } from "@common/constants";

export const getLinkTokenForNewConnectionQuerySchema = z.object({
    institutionName: z.nativeEnum(PLAID_INSTITUTIONS_NAMES).optional(),
    workspaceId: z.string().uuid().optional(),
    organizationId: z.string().uuid().optional(),
});

export const getLinkTokenForExistingConnectionPathParamsSchema = z.object({
    connectionId: z.coerce.number(),
});

export const getLinkTokenForExistingConnectionQuerySchema = z.object({
    addAccounts: z
        .enum(["true", "false"])
        .default("false")
        .transform((v) => v === "true"),
    enableStatements: z
        .enum(["true", "false"])
        .default("false")
        .transform((v) => v === "true"),
    workspaceId: z.string().uuid().optional(),
    organizationId: z.string().uuid().optional(),
});

export const addConnectionBodySchema = z.object({
    publicToken: z.string(),
    defaultEntityId: z.number().int().optional(),
    linkSessionId: z.string().max(100).optional(),
    mergeByMask: z.boolean().optional(),
});

export const getConnectionsQuerySchema = z.object({
    institutionId: z.string().optional(),
});

export const connectionIdPathParamsSchema = z.object({
    connectionId: z.coerce.number(),
});

export const getLinkTokenResponseSchema = z.object({
    token: z.string(),
});

export const relinkSuccessBodySchema = z.object({
    linkSessionId: z.string().max(100).optional(),
});

export const relinkSuccessResponseSchema = z.object({
    statementsApiEnabled: z.boolean(),
    statementsApiSupported: z.boolean(),
});

export type RelinkSuccessResponse = z.infer<typeof relinkSuccessResponseSchema>;
